var React = require('react');

function LyraL (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Symbols","fillRule":"evenodd","strokeWidth":"1"},React.createElement("g",{"id":"Atom/Icon/L/Blue","strokeWidth":"6"},React.createElement("path",{"id":"Combined-Shape","fill":"none","d":"M22,3 L3,3 L3,47 L47,47 L47,27 L22,27 L22,3 Z"}))));
}

LyraL.defaultProps = {"className":"fill-current stroke-current","version":"1.1","viewBox":"0 0 50 50"};

module.exports = LyraL;

LyraL.default = LyraL;
